import { useQuery } from '@tanstack/react-query'
import xcpemSec from '../../axiosInstances/xcpemSec'

export const useGetIncidentsLists = ({
  limit,
  offset = 0,
  monitoring_type = ''
}: {
  limit?: number
  offset?: number
  monitoring_type?: string
}) => {
  const fetchIncidents = async () => {
    const params = new URLSearchParams()
    params.append('offset', `${offset}`)
    if (limit) params.append('limit', `${limit}`)
    if (monitoring_type) params.append('group_name', `${monitoring_type?.trim()?.replace(/\s+/g, ' ')}`)

    const endpoint = `/api/v1/monitoring/incidents/list?${params.toString()}&total=true`

    const response = await xcpemSec.get<any[]>(endpoint, {
      headers: {
        Prefer: 'count=exact' // Add Prefer: count=exact header
      }
    })

    const newData = { data: response.data, total: response.headers['content-range'] }

    return newData
  }

  const { data, isLoading, error, isFetching, isFetched, refetch } = useQuery({
    queryKey: ['getIncidentsLists'],
    queryFn: fetchIncidents,
    enabled: false, // Disabled by default; must be triggered manually
    cacheTime: 0,
    staleTime: 0,
    retry: false
  })

  return { data, isLoading, error, isFetching, isFetched, refetch }
}

export const useGetGatewayOfflineLists = ({ incident_id = '' }: { incident_id?: string }) => {
  const fetchGatewayOffline = async () => {
    const params = new URLSearchParams()
    params.append('incident_id', `${incident_id}`)

    const endpoint = `/api/v1/monitoring/incidents/gateways-going-offline?total=true&${params.toString()}`

    const response = await xcpemSec.get<any[]>(endpoint, {
      headers: {
        Prefer: 'count=exact' // Add Prefer: count=exact header
      }
    })
    const newData = { data: response.data, total: response.headers['content-range'] }

    return newData
  }

  const { data, isLoading, error, isFetching, isFetched, refetch } = useQuery({
    queryKey: ['getGatewayOfflineLists'],
    queryFn: fetchGatewayOffline,
    enabled: false, // Disabled by default; must be triggered manually
    cacheTime: 0,
    staleTime: 0,
    retry: false
  })

  return { data, isLoading, error, isFetching, isFetched, refetch }
}

export const useGetNotificationSubscribe = ({ app_id = '' }: { app_id?: string }) => {
  const fetchNotificationSubscribe = async () => {
    const params = new URLSearchParams()
    params.append('app_id', `${app_id}`)

    const endpoint = `/api/v1/notification/sse/subscribe?app_type=web&${params.toString()}`

    const response = await xcpemSec.get<any[]>(endpoint)
    return response
  }

  const { data, isLoading, error, isFetching, isFetched, refetch } = useQuery({
    queryKey: ['getNotificationSubscribe'],
    queryFn: fetchNotificationSubscribe,
    enabled: false, // Disabled by default; must be triggered manually
    cacheTime: 0,
    staleTime: 0,
    retry: false
  })

  return { data, isLoading, error, isFetching, isFetched, refetch }
}
